// extracted by mini-css-extract-plugin
export default {"container":"ZCgJC","form":"YyoSP","name-input":"laeJh","amount-input":"qoYOD","calculated":"EGak3","chosen-item":"VhF1J","chosen-group":"u1R8g"};